module.exports = __webpack_public_path__ + "media/flags/ag-c1a8f4de.svg";